import React from 'react';
import TableContainer from '@mui/material/TableContainer';
import { createTheme, ThemeProvider } from '@mui/material';
import styled from 'styled-components';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-scroll';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import EvaluationTypesTable from './EvaluationTypesTable';
import AreasOfExpertise from './AreasOfExpertise';
import Button from '@mui/material/Button';

const theme = createTheme({
  typography: {
    fontFamily: 'Solway',
  },
  table: {
    fontSize: 28,
  },
});

const ServiceTable = () => {
  return (
    <>
      <ThemeProvider theme={theme}>
        <TableParent>
          <TableContainer>
            <TableTitle
              background='#2c3e50'
              fontSize='22px'
              color='white'
              align='center'
            >
              Evaluations
            </TableTitle>

            <StyledAccordion
              disableGutters
              className='eval-process-accordion'
              style={{ fontSize: '20px' }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{ fontWeight: '600' }}
              >
                What is the evaluation process like?
              </AccordionSummary>

              <AccordionDetails style={{ padding: '0', fontWeight: '100' }}>
                <EvaluationProcessContainer>
                  <p> Free 15-minute phone consultation</p>
                  <StyledDoubleArrowIcon />

                  <p>Complete intake and consent forms</p>
                  <StyledDoubleArrowIcon />
                  <p>Schedule the Evaluation</p>

                  <StyledDoubleArrowIcon />
                  <p>Evaluation Session</p>

                  <StyledDoubleArrowIcon />
                  <p>Analysis of Results & Parent Feedback</p>

                  <StyledDoubleArrowIcon />
                  <p>Initiation of Therapy</p>
                </EvaluationProcessContainer>

                <Link spy={true} smooth={true} duration={500} to='contactMe'>
                  <ButtonContainer>
                    <StyledButton>Request An Evaluation</StyledButton>
                  </ButtonContainer>
                </Link>
              </AccordionDetails>
            </StyledAccordion>

            <StyledAccordion
              disableGutters
              className='eval-process-accordion'
              style={{ fontSize: '20px' }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{ fontWeight: '600' }}
              >
                What are the different types of evaluations?
              </AccordionSummary>
              <EvaluationTypesTable />
              <AccordionDetails
                style={{ padding: '0', fontWeight: '100' }}
              ></AccordionDetails>
            </StyledAccordion>

            <TableTitle
              background='#2c3e50'
              fontSize='22px'
              color='white'
              align='center'
            >
              Therapy
            </TableTitle>

            <TherapyContainer>
              <div>
                Therapy sessions are available in 30, 45, or 60-minute
                durations. Typically, 30-minute sessions are recommended for
                younger children to support attention, motivation, and a
                positive association with therapy. Session times will be
                scheduled based on the client’s availability.
              </div>
            </TherapyContainer>

            <TableTitle background='#2c3e50' fontSize='22px' color='white'>
              Payment | Billing | Insurance
            </TableTitle>

            <PaymentContainer>
              <div>
                I offer <b>private-pay</b> rates with flexible scheduling and
                discounted packages for ongoing sessions. My rates reflect both
                session time and travel for in-home or on-site visits.    While I’m currently an out-of-network provider and do not bill
                insurance directly, I’ll provide you with everything you
                need to submit for reimbursement to your insurance.
              </div>

              <div>
                I also provide <b>package pricing</b> options for families who
                prefer to pay for multiple sessions in advance at a reduced
                rate. This helps ensure consistency and makes planning for
                therapy more predictable.
              </div>

              <div>
                In addition, I offer a limited <b>sliding scale</b> for families
                experiencing financial need. This allows fees to be adjusted
                based on household income so that services remain accessible to
                those who need them most.
              </div>



              <div>
                I accept credit/debit cards, HSA/FSA cards, checks, and cash as
                payment methods. For questions or detailed pricing information,
                please feel free to call or email.
              </div>
            </PaymentContainer>

            <TableTitle
              background='#2c3e50'
              fontSize='22px'
              color='white'
              align='center'
            >
              Areas of Expertise
            </TableTitle>
            <AreasOfExpertise />
          </TableContainer>
        </TableParent>
      </ThemeProvider>
    </>
  );
};

export default ServiceTable;

const TableParent = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 1rem;
  border-radius: 5px;
  width: 95%;
  margin: auto;
  justify-content: center;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px,
    rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
`;

const TableTitle = styled.p`
  font-size: ${(props) => props.fontSize};
  background: ${(props) => props.background};
  color: ${(props) => props.color};
  text-align: center;
  margin: auto;
  padding: 1rem;
`;

const StyledAccordion = styled(Accordion)`
  @media (min-width: 375px) and (max-width: 768px) {
    padding: 1rem;
  }

  .MuiAccordionSummary-content {
    justify-content: center;
    text-align: center;

    @media (min-width: 375px) and (max-width: 768px) {
      font-size: 16px;
    }
  }

  .request-eval-container {
    display: flex;
    justify-content: center;
    text-align: center;

    .button {
      height: 3rem;
      width: 15rem;
      font-size: 18px;
      font-family: 'Solway' !important;
      cursor: pointer;
      background-color: #008080;
      border-radius: 4px;
      color: white;
      margin-bottom: 1rem;
      border: none;
    }

    .button:hover {
      background-color: #00a2a2;
    }
  }
`;

const EvaluationProcessContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;

  p {
    text-align: center;
    font-size: 18px;

    @media (min-width: 375px) and (max-width: 768px) {
      font-size: 14px;
    }
  }

  @media (min-width: 375px) and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    .arrow-right {
      transform: rotate(90deg);
    }
  }
`;

const PaymentContainer = styled.div`
  display: flex;
  font-size: 18px;
  flex-direction: column;
  padding: 30px;
  gap: 10px;
  color: #2c3e50;
  line-height: 25px;
  @media (min-width: 375px) and (max-width: 768px) {
    font-size: 16px;
  }
`;

const TherapyContainer = styled.div`
  display: flex;
  font-size: 18px;
  padding: 30px;
  color: #2c3e50;
  line-height: 25px;
  @media (min-width: 375px) and (max-width: 768px) {
    font-size: 16px;
  }
`;

const StyledDoubleArrowIcon = styled(DoubleArrowIcon)`
  color: #54a399ff !important;

  @media (min-width: 375px) and (max-width: 768px) {
    transform: rotate(90deg);
  }
`;

const StyledButton = styled(Button)`
  background: #ff7849 !important;
  color: white !important;
  text-transform: none !important;
  font-size: 18px !important;
  justify-content: center !important;
  font-weight: 500px !important;
  padding: 10px !important;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-radius: 10px !important;

  :hover {
    background: #54a399ff !important;
  }
`;
